import request from '@/utils/request'

export function login(data) {
    return request({
        url: '/login/loginMember',
        method: 'post',
        headers: { 'oper': '登录', 'oper-type': 1083 },
        data
    })
}
export function useradd(data) {
    return request({
        url: '/login/register',
        method: 'post',
        headers: { 'oper': '用户注册', 'oper-type': 1084 },
        data
    })
}
export function getCode(data) {//区分
    return request({
        url: '/login/registerCode',
        method: 'post',
        headers: { 'oper': '手机号注册获取验证码', 'oper-type': 1085 },
        data
    })
}
export function getUserInfo(data) {
    return request({
        url: '/user/getUserInfo',
		method: 'post',
        headers: { 'oper': '获取用户信息', 'oper-type': 1086 },
        data
    })
}

export function logout() {
    return request({
        url: '/login/logout',
		headers: { 'oper': '登录退出', 'oper-type': 1087 },
        tip: false,
        method: 'get'
    })
}

export function areaList(data) {
    return request({
        url: '/area/list',
        method: 'post',
		headers: { 'oper': '地区列表', 'oper-type': 1088 },
        data
    })
}

export function wxCallLogin() {
    return request({
        url: '/wx-login/call-login',
        headers: { 'oper': '获取微信登录码', 'oper-type': 1089 },
        method: 'get'
    })
}

export function wxCallHeartBeat(params) {
    return request({
        url: '/wx-login/heart-beat',
        headers: { 'oper': '查询微信登录状态', 'oper-type': 1090 },
        method: 'get',
        params
    })
}

export function wxLoginMember(data) {
    return request({
        url: '/wx-login/loginMember',
        headers: { 'oper': '微信登录', 'oper-type': 1091 },
        method: 'post',
        data
    })
}
export function loginForget(data) {
  return request({
    url: '/login/forget',
    method: 'post',
	headers: { 'oper': '用户密码重置', 'oper-type': 1092 },
    data
  })
}
export function loginGetCode(data) {
  return request({
    url: '/login/getCode',
    method: 'post',
	headers: { 'oper': '重置密码获取验证码', 'oper-type': 1093 },
    data
  })
}
